<template>
	<div id="app">
		<index></index>
	</div>
</template>

<script>
	import index from "./components/index.vue";
	export default {
		name: "app",
		components: {
			index,
		},
	};
</script>

<style>
	#app {

		/* font-family: Helvetica, sans-serif; */
		/* text-align: center; */
	}

	html,
	body {
		margin: 0;
		padding: 0;
	}
</style>
